/* eslint-disable */
export default {
  all: 'Tous',
  company: 'Entreprise',
  personal: 'Personnel',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
